<template>
  <div class="search" v-if="topic">
    <div class="bg-color">
      <div class="inner">
        <div class="inner-img">
          <img class="img" :src="require('@assets/bigscreen/search.png')" />
        </div>
        <span class="word"
          >{{ topic }}<span class="cursor"></span
          ><span class="word-top-bg"></span
        ></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BigScreenSearch",
  props: {
    topic: { type: String, default: "" },
  },
  data() {
    return {};
  },
};
</script>
<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
.search {
  position: absolute;
  z-index: 10;
  left: 0;
  right: 0;
  bottom: 5.555vh;
  text-align: center;
  font-size: 0;

  .bg-color {
    display: inline-block;
    height: 4.815vh;
    line-height: 4.815vh;
    // background: rgba(255, 255, 255, 0.5);
    // background-image: linear-gradient(
    //   135deg,
    //   rgba(255, 255, 255, 0.6) 0%,
    //   rgba(208, 208, 208, 0.46) 100%
    // );
    // border: 0.1852vh solid rgba(208, 208, 208, 0.46); //2px
    // border-left: none;
    // border-radius: 1.111vh;
    overflow: hidden;
    .inner {
      display: flex;
      height: 100%;
      align-items: center;
      .inner-img {
        display: flex;
        height: 100%;
        align-items: center;
        background-image: url("~@assets/bigscreen/search_bg_01.png");
        background-size: 100% 100%;
        padding-right: 0.8vh;
      }
      .img {
        margin: 0 1.481vh;
        height: 2.5vh;
      }
      .word {
        position: relative;
        margin-left: -1vh;
        display: flex;
        align-items: center;
        // background-color: black;
        border-radius: 1.111vh;
        padding-left: 0.8vh;
        font-family: PingFangSC-Medium;
        font-size: 2.5vh;
        color: rgba(255, 255, 255, 1);
        overflow: hidden;
        background-image: url("~@assets/bigscreen/search_bg_03.png");
        background-repeat: no-repeat;
        background-position-x: right;
        background-size: auto 100%;
        .cursor {
          display: inline-block;
          // margin-left: 1.204vh;
          margin-right: 1.604vh;
          // background: rgba(50, 154, 255, 0.9);
          width: 0.1852vh;
          height: 2.5vh;
        }
        &::after {
          display: block;
          position: absolute;
          content: "";
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
          background-color: rgba(0, 0, 0, 1);
          filter: blur(10vh);
        }
        .word-top-bg {
          position: absolute;
          z-index: 1;
          left: 0;
          right: 0;
          bottom: 0;
          top: 0;
          background-image: url("~@assets/bigscreen/search_bg_02.png");
          background-size: auto 100%;
        }
      }
    }
  }
}
</style>
